import React, { useEffect, useRef, useState } from 'react'
import { Col, Row } from 'react-bootstrap';
import styleClasses from "../order.module.scss";
import styleClassesLocationModule from "../../../containers/location/Location.module.scss";
import { MIN_LOCATION_NAME_LENGTH, ROUTE_CHECKOUT, ROUTE_LOCATION_INFO } from "../../../constants";
import SearchLocation from './subcomponents/SearchLocation';
import { IMarketListingsQueryParams, LocationModel } from '../../../models/location.model';
import { locationMenuService } from '../../../services';
import SearchedLocationsCard from './subcomponents/SearchedLocationsCard';
import ShelterMap from '../../location/maps';
import MapsRender from '../../location/MapsRender';
import { useAuthState } from '../../../context/UserAuthentication';
import NoLocation from '../../location/NoLocation';
import {useQueryClient} from "react-query";
import {setLocation, useStoreLocation} from "../../../context/StoreLocation";
import { useLocation } from 'react-router';
import { useAppDispatch } from '../../../redux/store/store';
import { resetOrderDetail } from '../../../redux/slices/cartSlice';
import { LocationSelectMapIcon } from '../../../images/svgIcons/svg';
import { slugifyLocationName } from '../../location/slugifyLocations';
import { isEditStoreLocationModal } from '../../../components/utils';
import SearchLocationV2 from './subcomponents/SearchLocationV2';


interface IChangeStoreLocationProps {
    location?: any
    history?: any
    borderNone?:string
    closeModal?:() => void
    handleContinueButton?: (currentSelectedLocation) => void
    setSelectedLocation?:any
}
const ChangeLocation = (props: IChangeStoreLocationProps) => {
    const { location, history , borderNone, closeModal, handleContinueButton, setSelectedLocation} = props;

    const [zipCode, setZipCode] = React.useState<string>("");
    const [zipCodeCopy, setZipCodeCopy] = React.useState<string>("");
    const [showInfo, setShowInfo] = React.useState<boolean>(true);
    const [locationNotFound, setLocationNotFound] = React.useState<boolean>(false);
    const [isLoading, setLoading] = useState<boolean>(false);
    const [locations, setLocations] = useState<LocationModel[]>([]);
    const [selectedLocation, setSelectedLocations] = useState<LocationModel>(null);
    const [isLocationLoading, setLocationLoading] = useState<boolean>(false);
    const [isNoneDisplay, setNoneDisplay] = useState<boolean>(false);
    const [lat_longs, setLatLongs] = React.useState<any>([]);
    const [order_type, setOrderType] = React.useState<string>("");
    const [zipParamsCode, setZipParamsCode] = React.useState<string>();
    const [hovered, setHovered] = React.useState<any>(null);
    const [isDeviceIos, setIsDeviceIos] = React.useState(false);
    const [showMapPopUp, setShowMapPopUp] = React.useState<boolean>(false);
    const [markets, setMarkets] = React.useState<any>();
    const [marketsLoading, setMarketsLoading] = React.useState<boolean>(false)

    const { authInfo } = useAuthState();
    const {dispatch: locationDispatch } = useStoreLocation()
    const dispatch = useAppDispatch()
    const queryClient = useQueryClient();

    const myRefs = useRef([]);
    const myRef = useRef(null);
    const myListRef = useRef(null);
    const scrollRef = useRef(null);

    const { pathname } = useLocation()
    const isCheckout = pathname.includes( ROUTE_CHECKOUT )
    const executeScroll = () => myRef.current.scrollIntoView({ behavior: "smooth", block: "start" });

    useEffect(() => {
        fetchStates();
        checkLocationPermissionAndFetch();
    }, []);

    const checkLocationPermissionAndFetch = async () => {
        try {
            if (navigator.permissions && navigator.permissions.query && 'geolocation' in navigator) {
                const permissionResult = await navigator.permissions.query({ name: 'geolocation' });
                
                if (permissionResult.state === 'granted') {
                    // Permission already granted, fetch location automatically
                    console.log('Location permission already granted, fetching current location...');
                    handleCurrentLocation();
                }
            }
        } catch (error) {
            console.log('Permission API not supported or error checking permissions:', error);
            // Silently fail, don't auto-fetch if we can't check permissions
        }
    };

    useEffect(() => {
        var userAgent = navigator.userAgent || navigator.vendor;
        if (/iPad|iPhone|iPod|Mac/.test(userAgent) && !window.MSStream) {
            setIsDeviceIos(true);
        } else {
            setIsDeviceIos(false)
        }
        setLoading(false);
        onHistoryChange()
        // setLoading(true);
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);

        window.addEventListener("resize", () => {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty("--vh", `${vh}px`);
        });
    }, [history]);

    //used "useEffect" to handle scroll on location search.
    useEffect(() => {
        if (
            locations &&
            locations.length > 0 &&
            myRef.current &&
            !isLocationLoading
        ) {
            executeScroll();
        } else if (styleClasses.map_ctn_wrap_class && (locationNotFound || isNoneDisplay) && scrollRef.current) {
            executeNoLocScroll();
        }
    }, [locations, isLocationLoading, locationNotFound, isNoneDisplay]);


    const handleSearchChange = (searchValue) => {
        setZipCode(searchValue)
        handleEnter(searchValue)
    }

    const handleEnter = (searchValue) => {
         handlesearchClick(searchValue)
    }

    const getNearbyLocations = async (payload: any) => {
        if(authInfo.userId ) payload.user_id = authInfo.userId;
        if ( isCheckout ) payload.is_checkout = 1 
        return await locationMenuService.getNearbyLocations(payload)
    }

    const handleMouseOverBox = (marker) => {
        setHovered(marker);
    };

    const handleScroll = () => {
        document.documentElement.scrollTop = 0;
        myListRef.current.scrollTop = 0
    }

    const executeNoLocScroll = () => {
        let extraDiv = document.querySelector('.' + styleClasses.map_ctn_wrap + ' > div > div');
        if (extraDiv && extraDiv.children[1]) {
            extraDiv.children[1].remove();
        }
        scrollRef.current.scrollIntoView({ behavior: "smooth", block: "start" })
    };

    const removeSearch = () => {
        setZipCode('')
        setZipCodeCopy('')
        setLocations([]);
        setLocationLoading(false);
        setNoneDisplay(true);
        setLatLongs([]);
    }

    const searchLocation = async (search) => {
        const array = [];
        const response = await getNearbyLocations({ address: search });
        setLocationNotFound(false);
        setLoading(false);
        const data = response.data.data;
        data.map(function (data) {
            array.push({
                latitude: data.lat,
                longitude: data.long,
                name: data.name,
                data: data,
                order_type: order_type,
                zip_code_param: zipParamsCode,
            });
        });
        return { response, data, array }
    }

    const filterSearchedData = async (search:string) => {
        setSelectedLocations(null)
        if (search.length >= MIN_LOCATION_NAME_LENGTH) {
            const {response,data,array} = await searchLocation(search)
            setLatLongs(array);
            if (typeof response.data === "undefined" || data.length == 0) {
                setLocations([]);
                setLocationLoading(false);
                setNoneDisplay(true);
            } else {
                setLocations(data);
                setLocationLoading(false);
                setNoneDisplay(false);
            }
        } else {
            setLocations([]);
            setLocationLoading(false);
            setNoneDisplay(true);
        }
    }

    // const processChange = debounce(() => saveInput());


    //? Long Funciton's
    const handlesearchClick = async (searchValue) => {
        try {
            setLocationNotFound(false);
            if (searchValue === "") return;
            setNoneDisplay(false);
            setLocationLoading(true);
            setLocations([]);
            setLatLongs([]);
            let search = searchValue;
            setZipCode(search);
            setZipCodeCopy(search);
            filterSearchedData(search)
        } catch (error) {
            setLoading(false);
            console.error(error.message);
            setLocationLoading(false);
            setNoneDisplay(true);
        }
    };

    const handleCurrentLocation = async () => {
        try {
            // Check if geolocation is supported
            if (!navigator.geolocation) {
                console.error("Geolocation is not supported by this browser.");
                setLocationNotFound(true);
                setLocationLoading(false);
                return;
            }

            setLocationLoading(true);
            setLocationNotFound(false);
            
            navigator.geolocation.getCurrentPosition(
                async function (position) {
                    let array = [];
                    const response = await getNearbyLocations({
                        lat: position.coords.latitude,
                        long: position.coords.longitude
                    });
                    setLoading(false);
                    response.data.data &&
                        response.data.data.map(function (data) {
                            if (
                                typeof data.lat !== "undefined" &&
                                data.lat !== null &&
                                typeof data.long !== "undefined" &&
                                data.long !== null
                            ) {
                                array.push({
                                    latitude: data.lat,
                                    longitude: data.long,
                                    name: "abc",
                                    data: data,
                                    order_type: order_type,
                                    zip_code_param: zipParamsCode,
                                });
                            }
                        });
                    setLatLongs(array);
                    setLocations(response.data.data);
                    setLocationLoading(false);
                    if (response.data.data.length == 0) {
                        setNoneDisplay(true);
                    }
                },
                function (error) {
                    // Error callback
                    console.error("Geolocation error:", error);
                    console.error("Error code:", error.code);
                    console.error("Error message:", error.message);
                    
                    setLocationNotFound(true);
                    setLoading(false);
                    setLocationLoading(false);
                    setNoneDisplay(true);
                    
                    // Handle specific error types
                    switch (error.code) {
                        case error.PERMISSION_DENIED:
                            console.log("User denied the request for Geolocation.");
                            break;
                        case error.POSITION_UNAVAILABLE:
                            console.log("Location information is unavailable.");
                            break;
                        case error.TIMEOUT:
                            console.log("The request to get user location timed out.");
                            break;
                        default:
                            console.log("An unknown error occurred.");
                            break;
                    }
                },
                {
                    enableHighAccuracy: true,
                    timeout: 10000,
                    maximumAge: 300000
                }
            );
        } catch (error) {
            console.error("Error in handleCurrentLocation:", error);
            setLocationNotFound(true);
            setLoading(false);
            setLocationLoading(false);
            setNoneDisplay(true);
        }
    };

    const onHistoryChange = async () => {
        try {
            const query = new URLSearchParams(window.location.search);
            var order_type = query.get("order_type");
            setOrderType(order_type);
            var zip_code = query.get("postal_code");
            if (zip_code) {
                setZipParamsCode(zip_code);
                setZipCode(zip_code);
                let array = [];
                const response = await getNearbyLocations({
                    address: zip_code
                })
                setLocationNotFound(false);
                setLoading(false);
                response.data.data &&
                    response.data.data.map(function (data) {
                        array.push({
                            latitude: data.lat,
                            longitude: data.long,
                            name: data.name,
                            data: data,
                            order_type: order_type,
                            zip_code_param: zipParamsCode,
                        });
                    });
                setLatLongs(array);
                setLocations(response.data.data);
                setLocationLoading(false);
                if (response.data.data.length == 0) {
                    setNoneDisplay(true);
                }
            }
        } catch (error) {
            setLoading(false);
            console.error(error.message);
            setLocationLoading(false);
            setNoneDisplay(true);
        }
    }

    const openedMarker = (marker) => {
        setHovered(marker.data.id);
        if (myRefs !== null || myRefs.current !== null || myRefs.current.length > 0) {
            let scroll = myRefs.current[marker.data.id].offsetTop;
             scroll = scroll - 200;
            document.querySelector('#scroll2').scrollTo(0, scroll);
            if (typeof globalThis.bodyscroll !== 'undefined') {
                globalThis.bodyscroll.setPosition(0, scroll);
            }
        }
    };

    const fetchStates = async (lat?: number, lng?: number) => {
        try {
            setMarketsLoading(true)
            const payload : IMarketListingsQueryParams = {};
            if(authInfo.userId) payload.customer_id = authInfo.userId
            if ( isCheckout ) payload.is_checkout = 1 
            payload.lat = lat ?? "";
            payload.long = lng ?? "";
            const response = await locationMenuService.getMarketListings(payload);
            if (response.data) setMarkets(response.data.data.data)
            setMarketsLoading(false)
        } catch (error) {
            console.log("error in fetching markets for locations", error)
            setMarketsLoading(false)
        }
    }

    const handleMarkets = (id) => {
        const found = markets.find(market => market.id === id)
        setZipCode(found.name)
        let array = [];
        found.locations.map(function (data) {
            array.push({
                latitude: data.lat,
                longitude: data.long,
                name: data.name,
                data: data,
                order_type: order_type,
                zip_code_param: zipParamsCode,
            });
        });
        setLatLongs(array);
        setLocations(found.locations);
        setNoneDisplay(false)
        setLocationNotFound(false)
    }

    const onMouseOut = (event, marker) => {
        setHovered(null);
    }

    const handleSelectedLocation = (currentSelectedLocation: LocationModel) => {
        setSelectedLocations(currentSelectedLocation);
        if(handleContinueButton){
            handleContinueButton(currentSelectedLocation)
            setSelectedLocation(currentSelectedLocation);
        }else{
            continueClickHandler(currentSelectedLocation)
        }
    }

    const continueClickHandler = (currentSelectedLocation?) => {
        const locationToUse = currentSelectedLocation || selectedLocation;
        setLocation(locationDispatch, locationToUse);
        queryClient.refetchQueries(["get-cart", locationToUse.id]);
        dispatch(resetOrderDetail())
        closeModal()
    }

    const isContinueDisabled = () => {
        return selectedLocation ? false : true
    }

    const getInfo = (id) => {
        let url = `${ROUTE_LOCATION_INFO}/${slugifyLocationName(id)}`;    
        window.open(url, '_blank');
    };

       const showStates = !isLocationLoading && (isNoneDisplay || locationNotFound || (zipCode === "" && locations.length === 0))
    return (
        <div className={`${styleClasses.change_location_wrapper} full_width_mob new_form_design w-75 my-0 mx-auto ${isEditStoreLocationModal() && "px-md-3"}`}>
            <Col md="6" lg="12" xxl="12">
                <SearchLocationV2
                    styleClasses={styleClasses}
                    searchLocationProps={{ myListRef, showInfo, handleSearchChange, handleEnter, isNoneDisplay, locationNotFound, isLocationLoading, handleCurrentLocation, removeSearch }}
                    locationRenderProps={{ locations, myRefs, handleMouseOverBox, hovered, styleClasses, myRef, zipCode, handleScroll, isDeviceIos, getInfo, zipCodeCopy }}
                    noLocationProps={{ scrollRef, markets, handleMarkets, showStates }}
                />
            </Col>

            <Row>
                <Col md="6" lg="12" xxl="12" className={`pt-3`}>
                    <SearchedLocationsCard
                    styleClasses={styleClasses}
                    location={locations}
                    isDeviceIos={isDeviceIos}
                    isLocationLoading={isLocationLoading || marketsLoading}
                    myRefs={myRefs}
                    hovered={hovered}
                    handleSelectedLocation={handleSelectedLocation}
                    currentSelectedLocation={selectedLocation}
                    getInfo={getInfo}
                    />
                    {showStates ? (
                        //markets && markets.length > 0  ?
                        <NoLocation scrollRef={scrollRef} styleClasses={styleClasses} zipCode={zipCodeCopy} markets={markets} handleMarkets={handleMarkets} handleScroll={handleScroll}
                        isRedirectToAllLocationsPage= {false}  
                        borderNone={'d-none'}
                    />
                    ) : (
                        ""
                    )}
                </Col>
            </Row>
        </div>
    )
}

export default ChangeLocation